(function ($) {
    $('.offer-20 .offer-20__select.variant li').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const variant_id = $(this).data('variant');
        const variant_title = $(this).find('.variant-title-mobile').text();
        const variant_length = $(this).data('variant-length');
        const variant_show_price_months = $(this).data('variant-show-price-months');
        const show_promo_prices = $(this).parents('.offer-20').data('showPromoPrices');
        const hide_cta = $(this).data('hide-cta');

        $('.offer-20_column').each(function () {

            const variants = $(this).data('variants')
            const $price_package = $(this).find('.prices .price_package .price');
            const $price_month = $(this).find('.prices .price-month strong');
            const $price_month_del = $(this).find('.prices .price-month del');
            const $price_months = $(this).find('.price_package .price_for_x_months');

            if ( ( !show_promo_prices && parseInt(variant_length) !== 1 ) || (show_promo_prices && variants[variant_id]['is_on_sale'] ) ) {
                $price_month_del.show();
            } else {
                $price_month_del.hide();
            }

            if(variant_show_price_months) {
                $price_months.show();
            } else {
                $price_months.hide();
            }

            $(this).find('.variant_length span').text(variant_title);

            let price_per_month = formatPrice(variants[variant_id]['price'] / variant_length);
            let base_price_per_month = ( ! show_promo_prices) ? formatPrice(variants[0]['price']) : formatPrice(variants[variant_id]['display_regular_price']);

            $price_month.text(price_per_month);
            $price_package.html(variants[variant_id]['price_html']);
            $price_month_del.text(base_price_per_month);

            const $add_to_cart = $(this).find('.product a');
            const $gtm4wp_data = $(this).find('.gtm4wp_productdata')
            const variants_gtm4wp_data = $(this).data('gtm4wp-data');

            let savings = formatPrice(variants[0]['price'] * variant_length - variants[variant_id]['price']);
            const $package_savings = $(this).find('.package_savings');
            const savings_copy = $package_savings.data('prototype').replace('%s', savings);

            $package_savings.text(savings_copy);
            if (savings !== '0') {
                $(this).find('.package_savings').removeClass('hidden');
            } else {
                $(this).find('.package_savings').addClass('hidden');
            }

            const $properties = $(this).find('.property_group, .property');

            $properties.each(function () {
                if (!$(this).data('showOn').includes(variant_id.toString())) {
                    $(this).addClass('hidden');
                } else {
                    $(this).removeClass('hidden');
                }

                if ($(this).data('lockedOn').includes(variant_id.toString())) {
                    $(this).addClass('locked');
                } else {
                    $(this).removeClass('locked');
                }
            });

            const $omnibus = $(this).find('.omnibus');
            $omnibus.html(variants[variant_id]['omnibus_msg']);

            $add_to_cart.attr('href', `?add-to-cart=` + variants[variant_id]['variation_id']);
            $add_to_cart.attr('data-product_id', variants[variant_id]['variation_id'])
            $gtm4wp_data.attr('data-gtm4wp_product_data', variants_gtm4wp_data[variant_id]);

            if (hide_cta) {
                $add_to_cart.hide();
            } else {
                $add_to_cart.show();
            }
        });

        const $package_info = $('.package-info');
        if ($package_info.length > 0) {
            const package_description = $package_info.data('descriptions')[variant_id];
            $package_info.html(package_description);
        }
    });

    $('.offer-20 .offer-20__select.package li').on('click', function (e) {
        $(this).parent().find('li').removeClass('active');
        $(this).addClass('active');
        const variant_id = $(this).data('packageId');

        $('.offer-20_column').each(function () {
            if ($(this).data('package') === variant_id) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        })
    });

    $('.offer-20 .property').on('click', function () {
        const $description = $(this).find('.property-description');

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $description.slideUp(300);
        } else {
            if ($(this).find('.property-description').length < 1) return;
            $('.offer-20 .property').removeClass('active');
            $('.offer-20 .property .property-description').slideUp(300);
            $description.slideDown(300);
            $(this).addClass('active');
        }
    });

    $('.offer-20 .property .property-description').on('click', function (e){
        e.stopPropagation();
    });

    document.querySelectorAll('.package-select-wrapper').forEach(elem => new IntersectionObserver((entries, observer) => {
            for (const entry of entries) {
                entry.target.classList.toggle('stuck', !entry.isIntersecting)
            }
        },
        {
            rootMargin: `-${parseInt(window.getComputedStyle(elem).getPropertyValue('top')) + 1}px 0px`, // shrink the viewport to element top value +1px to trigger observer when element has reach it's sticky position
            threshold: 1, // percentage of element that must be visible before intersecting becomes true
        }).observe(elem))

    function formatPrice(price) {
        price = (Number.isInteger(price)) ? price : price.toFixed(2);
        return price.toString().replace('.', ',');
    }

    function adjustColumnTopHeights() {

        const $columnTop = $('.offer-20_column-top');
        let columnTopHeight = 0;
        $columnTop.css('min-height', '');

        $columnTop.each(function () {
            if ($(this).innerHeight() > columnTopHeight) {
                columnTopHeight = $(this).innerHeight();
            }
        });

        $columnTop.css('min-height', columnTopHeight);

    }

    $(document).ready(adjustColumnTopHeights);
    $(window).on('resize', adjustColumnTopHeights);

})(jQuery);